import React, { createRef, useCallback, useEffect, useState } from "react";
import Select from '../common/Select';
import { DropdownIndicator } from "../../utils/dropdown-override";
import Mathjax from "../common/Mathjax";

function checkOverflow(el) {
    var curOverflow = el.style.overflow;

    if (!curOverflow || curOverflow === "visible") el.style.overflow = "hidden";

    var isOverflowing =
        el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;

    el.style.overflow = curOverflow;

    return isOverflowing;
}

function GroupBtns({
    attribs,
    activeAttrib,
    onSelect,
    Dyn,
    isOrderBy,
    showSelect,
    setShowSelect,
}) {
    const divRef = createRef();

    useEffect(() => {
        setShowSelect(divRef.current && checkOverflow(divRef.current));
    }, [divRef]);
    return (
        <div className="tde-text-center tde-py-2 tde-flex-1" ref={divRef}>
            <div className="tde-px-2 tde-pb-2">
                <b>{isOrderBy ? "Order" : "Group"} Cards By</b>
            </div>
            {!showSelect &&
                attribs?.map((attr, i) => {
                    return (
                        <button
                            onClick={() => onSelect(attr)}
                            key={i}
                            className={
                                "btn tde-cursor-pointer tde-mx-1" +
                                (attr.id === activeAttrib?.id
                                    ? " tde-active"
                                    : "")
                            }
                        >
                            <Mathjax value={attr.name} />
                        </button>
                    );
                })}
            {showSelect && (
                <Select
                    Dyn={Dyn}
                    aria-label={"Group By"}
                    className="tde-input tde-px-2 tde-flex-1 tde-select-input tde-input-select tde-data-colors tde-select-right"
                    isClearable={false}
                    value={activeAttrib}
                    options={attribs}
                    menuPlacement="top"
                    // openMenuOnFocus
                    onChange={onSelect}
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.id}
                    isSearchable={false}
                    tabSelectsValue={false}
                    placeholder={
                        <div className="tde-select-placeholder">
                            {"Select..."}
                        </div>
                    }
                    components={{
                        Option: ({
                            data,
                            innerProps,
                            children,
                            innerRef,
                            isSelected,
                            isFocused,
                        }) => (
                            <div
                                className={
                                    "tde-select-option" +
                                    (isSelected? " tde-selected": "") +
                                    (isFocused? " tde-focused": "")
                                }
                                role="option"
                                aria-selected={isSelected ? "true" : "false"}
                                aria-label={data.name}
                                title={data.name}
                                {...innerProps}
                                ref={innerRef}
                            >
                                <div className="tde-s1">{children}</div>
                            </div>
                        ),
                        DropdownIndicator,
                    }}
                />
            )}
        </div>
    );
}

function Footer({ Dyn, attr, type, onGroupBy, onOrderBy }) {
    const [attrib, setAttrib] = useState(attr);
    const [graphType, setGraphType] = useState(type);
    const [isG1OverFflowing, setIsG1OverFflowing] = useState(false);
    const [isG2OverFflowing, setIsG2OverFflowing] = useState(false);
    const [ignoreShowSelect, setIgnoreShowSelect] = useState(false);
    // Handle container resize
    useEffect(() => {
        function resizeHandler() {
            setIgnoreShowSelect(true);
            setTimeout(() => {
                setIgnoreShowSelect(false);
            }, 100);
        }
        Dyn.mediator.subscribe( "plot:containerResized", resizeHandler );
        return () => {
            // On unmount.
            Dyn.mediator.remove( "plot:containerResized", resizeHandler );
        }
    }, [])
    const onSelect = useCallback((attr, type) => {
        setGraphType(type);
        setAttrib(attr);
        if (type == "groupBy") {
            onGroupBy(attr);
        } else if (type === "orderBy") {
            onOrderBy(attr);
        }
    }, []);
    const categoricalAttribs = [];
    const numericalAttribs = [];
    Dyn.dataSet?.attribs?.forEach((attr) => {
        if (attr.id !== "id") {
            // const a = {id: attr.id, name: attr.name};
            if (attr.getDataType(false) === "numerical") {
                numericalAttribs.push(attr);
            } else {
                categoricalAttribs.push(attr);
            }
        }
    });

    // Show select either one of the group is overflowing
    let showSelect = false;
    if(!ignoreShowSelect) {
        showSelect = isG1OverFflowing || isG2OverFflowing;
    }

    return (
        <div className="tde-elem-play-footer tde-border tde-d-flex">
            {categoricalAttribs.length > 0 && (
                <GroupBtns
                    attribs={categoricalAttribs}
                    activeAttrib={graphType === "groupBy" ? attrib : null}
                    onSelect={(attr) => onSelect(attr, "groupBy")}
                    Dyn={Dyn}
                    showSelect={showSelect}
                    setShowSelect={setIsG1OverFflowing}
                />
            )}
            {numericalAttribs.length > 0 && (
                <GroupBtns
                    attribs={numericalAttribs}
                    activeAttrib={graphType === "orderBy" ? attrib : null}
                    onSelect={(attr) => onSelect(attr, "orderBy")}
                    Dyn={Dyn}
                    isOrderBy={true}
                    showSelect={showSelect}
                    setShowSelect={setIsG2OverFflowing}
                />
            )}
        </div>
    );
}

export default Footer;
